import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import AuroraBackground from "@/components/AuroraBackground";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppShell from "@/components/AppShell";

import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Start from "@/pages/Start";
import Dashboard from "@/pages/Dashboard";
import CreateBill from "@/pages/CreateBill";
import JoinBill from "@/pages/JoinBill";
import BillRoom from "@/pages/BillRoom";
import GuestPay from "@/pages/GuestPay";
import JoinLink from "@/pages/JoinLink";
import Payouts from "@/pages/Payouts";
import AdminDashboard from "@/pages/AdminDashboard";

const Shell = (el) => (
  <ProtectedRoute>
    <AppShell>{el}</AppShell>
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <AuroraBackground />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/start" element={<Start />} />
            <Route path="/j/:code" element={<JoinLink />} />
            <Route path="/pay/:code" element={<GuestPay />} />

            <Route path="/" element={Shell(<Dashboard />)} />
            <Route path="/create" element={Shell(<CreateBill />)} />
            <Route path="/join" element={Shell(<JoinBill />)} />
            <Route path="/payouts" element={Shell(<Payouts />)} />
            <Route path="/bill/:id" element={Shell(<BillRoom />)} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute adminOnly>
                  <AppShell>
                    <AdminDashboard />
                  </AppShell>
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" theme="dark" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
